import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { Pagination, PaginationParams } from '@/common/types';
import { API_URL } from '@/dtos';
import { IReceiptDtoSourceEnum } from '@/dtos/models';
import { Receipt } from '@/modules/MyDocuments/myDocuments.types';

interface ReceiptPayload {
  receipt_id?: number;
  claim_id?: number;
  document_id?: number;
  file_url?: string;
  filename?: string;
  provider_name?: string;
  created_at?: string;
}

interface Props extends Partial<PaginationParams> {
  employeeId?: string;
  available?: boolean;
  source?: IReceiptDtoSourceEnum;
}

const useGetReceiptsQuery = ({ page, perPage, searchString, employeeId, available, source }: Props) => {
  const { data, isLoading } = useQuery(
    [API_URL.DOCUMENTS_RECEIPTS_FILES, page, perPage, searchString, available, source],
    () =>
      // TODO: fix types
      api.get<Pagination<ReceiptPayload>>(API_URL.DOCUMENTS_RECEIPTS_FILES, {
        params: {
          ...(searchString ? { search_value: searchString } : {}),
          ...(available !== undefined ? { available } : {}),
          ...(source ? { source } : {}),
          page: page && page >= 0 ? page - 1 : 0,
          size: perPage || 10,
          employee_id: employeeId,
        },
      }),
    {
      retry: 0,
    }
  );

  const receipts: Receipt[] = useMemo(
    () =>
      data?.data?.content?.map((receipt) => ({
        id: toString(receipt?.receipt_id),
        claimId: toString(receipt?.claim_id),
        documentId: toString(receipt?.document_id),
        fileUrl: receipt?.file_url,

        fileName: receipt?.filename,
        providerName: receipt?.provider_name,
        createdAt: receipt?.created_at,
      })) || [],
    [data]
  );

  return {
    receipts,
    total: data?.data?.totalElements || 0,
    isReceiptsLoading: isLoading,
  };
};

export default useGetReceiptsQuery;
